export default __webpack_public_path__ + "static/img21h-41481c6d5bd0bc50388ec1c919e82a3f.jpg";